export const LinkData = [
  {
    id: 1,
    title: "Inicio",
    url: "/",
  },
  {
    id: 2,
    title: "Sobre",
    url: "/about#about",
  },
  {
    id: 3,
    title: "Carreras",
    url: "/Careers#careers",
  },
  {
    id: 4,
    title: "Galeria",
    url: "/Galeria#gallery",
  },
  {
    id: 5,
    title: "Blog",
    url: "/blog#courses",
  },

  {
    id: 6,
    title: "Trayectoria",
    url: "/trayectoria",
  },
]
export const courses = [
  {
    id: 1,
    duration: "24 Meses",
    module: "24 Meses",
    ranking: "5.00",
    people:"+800",
    url:"/cheff",
    cover: "../images/chef.webp",
    title: "Chef Profesional",
    text: "Sumérgete en el apasionante mundo de la cocina peruana y conviértete en un experto culinario reconocido a nivel internacional.",
    span1: "Carrera",
    span2: "Tecnicas Culinarias",
  },
  {
    id: 2,
    duration: "12 Meses",
    module: "12 Meses",
    ranking: "4.50",
    people:"+400",
    url:"/bartender#bartender",
    cover: "../images/bartender.webp",
    title: "Bartender Profesional",
    text: "Desde los secretos de la mixología clásica hasta las tendencias más innovadoras, domina el arte de crear cócteles que deleiten los sentidos.",
    span1: "Especialidad",
    span2: "Mixología",
  },
  {
    id: 3,
    duration: "24 Meses",
    module: "24 Meses",
    ranking: "4.80",
    url:"/aviacion",
    people:"+600",
    cover: "../images/aviacion.webp",
    title: "Aviación Comercial",
    text: "Alza el vuelo hacia una carrera apasionante. Conviértete en Counter Profesional y Tripulante de Cabina y explora el mundo desde las alturas.",
    span1: "Carrera",
    span2: "Servicio a Bordo",
  },
  /*
    {
    id: 4,
    cover: "../images/course-6-1.jpg",
    title: "INNAHIBILITADO",
    text: "Este curso estará disponible pronto. Mantente al pendiente de nuestras actualizaciones.",
    span1: "Próximamente",
    span2: "Próximamente",
  },*/
];

export const blogs = [
  {
    id: 1,
    cover: "../images/cevatips.png",
    title: "CEVATIPS",
    text: "Aprende con cevatur, tenemos varios cevatips que necesitas conocer para facilitar tu vida",
    span1: "Gastronomía",
    span2: "Cocina Profesional",
    url: "/single-blog",
  },
  {
    id: 2,
    cover: "../images/tragos.png",
    title: "CEVAFEST",
    text: "Aprende alguna de nuestras recetas, luego estudia con nosotros y aprende lo mejor de la cocteleria",
    span1: "Bar y Coctelería",
    span2: "Mixología",
    url: "/single-blog2",

  },
  {
    id: 3,
    cover: "../images/cevacruz.png",
    title: "CEVACTÚA",
    text: "Ten conocimientos de primeros auxilios que podran ayudarte en el futuro, siempre debes estar preparado para todo.",
    span1: "Carrera",
    span2: "Turismo",
    url: "/single-blog3",

  },
  /*
    {
    id: 4,
    cover: "../images/course-6-1.jpg",
    title: "INNAHIBILITADO",
    text: "Este curso estará disponible pronto. Mantente al pendiente de nuestras actualizaciones.",
    span1: "Próximamente",
    span2: "Próximamente",
  },*/
];
